<template>
    <div class="container-resume">
        <div class="resume">
            <div class="item" v-for="item in Items" :key="item.title">

                <div class="item-title">
                    <i :class="item.icon"></i>
                    <h4>{{ item.title }}</h4>
                </div>

                <div class="item-value" :class="{down: item.pourcentage < 0, up: item.pourcentage > 0}">
                    <h5 v-html="numberSpacing(item.value)"></h5>
                    <i class="fa-solid fa-arrow-right"></i>
                    <p>{{ item.pourcentage }}<span class="pourcentage">%</span></p>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            Items: Array,
        },
        
        methods: {
            numberSpacing(number) {
                return "<span>" + number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "</span><span>") + "</span>";
             
            }
        },
    }
</script>